module.exports = __webpack_public_path__ + "static/img/betslip-dia-guide-txt.cf0255d.png";